module.exports = __webpack_public_path__ + "img/P150T_weapon_67.0408eb96.png";